function equalizeRowHeights(children) {
	var maxHeight = 0;

	$(children).each(function(){
		$(this).height('auto');

		if ($(this).height() > maxHeight) {
			maxHeight = $(this).height();
		}
	});

	$(children).height(maxHeight);
}

jQuery(window).load(function() {
	$(window).resize(function() {
		if ($(this).width() >= 767) {
			$('.row.equal-height').each(function() {
				equalizeRowHeights($('.item', this));
			});

			equalizeRowHeights($('.row.equal-height-inner .inner'));
		}
		else {
			$(".row.equal-height .item").height();
			equalizeRowHeights($('.row.equal-height-inner .inner'));
		}
	}).resize();
});

var Sage = {
	// All pages
	'common': {
		init: function() {
                                    var $pageBanner = $('.page-banner');

                                    if ($('body').hasClass('home') || $pageBanner.hasClass('banner-full-video') || $pageBanner.hasClass('banner-full')) {
                                        BackgroundCheck.init({
                                            targets: '.navbar-nav, .navbar-brand',
                                            images: '.item.active .slider-bg, .page-banner .caption-wrapper'
                                        });
                                    }

			//Add click scrolling on desktop devices.
			var $scroller = $('.side-scroll').kinetic();

			$('.footer-nav > li > a').click(function() {
				if ($(window).width() <= 600 && !$(this).parent().hasClass("open")) {
					$(this).parent().addClass('open');
					console.log('opening');
					return false;
				}
			});

			$('.freebie-form').submit(function() {
				var $form = $(this);

				$('.btn-arrow', $form).addClass('loading');

				var data = {
					action: 'carm_freebie_download',
					security: MyAjax.ajaxnonce,
					name: $("input[name='NAME']", $form).val(),
					email: $("input[name='EMAIL']", $form).val(),
					group: $("input[name='GROUP']", $form).val()
				};

				$.post(MyAjax.ajaxurl, data, function(response) {
					console.log("Response: " + response);

					if (response === 'success'){
						//console.log('slide')
						$form.slideUp(400, function(){
							$form.html('<h5 class="alert alert-success">The form has been submitted successfully. Your freebie has been sent to your email.</h5>').slideDown();
						});
					}
				});

				return false;
			});
		},
		finalize: function() {
		}
	},
	// Home page
	'home': {
		init: function() {
			$('.carousel').carousel({
				interval: 12000,
			});

                                    $('.carousel').on('slid.bs.carousel', function () {
                                        BackgroundCheck.set('images', '.item.active .slider-bg');
                                        BackgroundCheck.refresh();
                                    });
		}
	}
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
	fire: function(func, funcname, args) {
		var fire;
		var namespace = Sage;
		funcname = (funcname === undefined) ? 'init' : funcname;
		fire = func !== '';
		fire = fire && namespace[func];
		fire = fire && typeof namespace[func][funcname] === 'function';

		if (fire) {
			namespace[func][funcname](args);
		}
	},
	loadEvents: function() {
		// Fire common init JS
		UTIL.fire('common');

		// Fire page-specific init JS, and then finalize JS
		$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                                    //console.log(classnm);
			UTIL.fire(classnm);
			UTIL.fire(classnm, 'finalize');
		});

		// Fire common finalize JS
		UTIL.fire('common', 'finalize');
	}
};

// Load Events
$(document).ready(UTIL.loadEvents);

// Global array of countries and their respective states
var Countries = [
	{ "name": "United States", "abbr": "US", "states": [{ "name": "Alabama", "abbr": "AL" },
	{ "name": "Alaska", "abbr": "AK" },
	{ "name": "Arizona", "abbr": "AZ" },
	{ "name": "Arkansas", "abbr": "AR" },
	{ "name": "California", "abbr": "CA" },
	{ "name": "Colorado", "abbr": "CO" },
	{ "name": "Connecticut", "abbr": "CT" },
	{ "name": "Delaware", "abbr": "DE" },
	{ "name": "District Of Columbia", "abbr": "DC" },
	{ "name": "Florida", "abbr": "FL" },
	{ "name": "Georgia", "abbr": "GA" },
	{ "name": "Hawaii", "abbr": "HI" },
	{ "name": "Idaho", "abbr": "ID" },
	{ "name": "Illinois", "abbr": "IL" },
	{ "name": "Indiana", "abbr": "IN" },
	{ "name": "Iowa", "abbr": "IA" },
	{ "name": "Kansas", "abbr": "KS" },
	{ "name": "Kentucky", "abbr": "KY" },
	{ "name": "Louisiana", "abbr": "LA" },
	{ "name": "Maine", "abbr": "ME" },
	{ "name": "Maryland", "abbr": "MD" },
	{ "name": "Massachusetts", "abbr": "MA" },
	{ "name": "Michigan", "abbr": "MI" },
	{ "name": "Minnesota", "abbr": "MN" },
	{ "name": "Mississippi", "abbr": "MS" },
	{ "name": "Missouri", "abbr": "MO" },
	{ "name": "Montana", "abbr": "MT" },
	{ "name": "Nebraska", "abbr": "NE" },
	{ "name": "Nevada", "abbr": "NV" },
	{ "name": "New Hampshire", "abbr": "NH" },
	{ "name": "New Jersey", "abbr": "NJ" },
	{ "name": "New Mexico", "abbr": "NM" },
	{ "name": "New York", "abbr": "NY" },
	{ "name": "North Carolina", "abbr": "NC" },
	{ "name": "North Dakota", "abbr": "ND" },
	{ "name": "Ohio", "abbr": "OH" },
	{ "name": "Oklahoma", "abbr": "OK" },
	{ "name": "Oregon", "abbr": "OR" },
	{ "name": "Pennsylvania", "abbr": "PA" },
	{ "name": "Puerto Rico", "abbr": "PR" },
	{ "name": "Rhode Island", "abbr": "RI" },
	{ "name": "South Carolina", "abbr": "SC" },
	{ "name": "South Dakota", "abbr": "SD" },
	{ "name": "Tennessee", "abbr": "TN" },
	{ "name": "Texas", "abbr": "TX" },
	{ "name": "Utah", "abbr": "UT" },
	{ "name": "Vermont", "abbr": "VT" },
	{ "name": "Virgin Islands", "abbr": "VI" },
	{ "name": "Virginia", "abbr": "VA" },
	{ "name": "Washington", "abbr": "WA" },
	{ "name": "West Virginia", "abbr": "WV" },
	{ "name": "Wisconsin", "abbr": "WI" },
	{ "name": "Wyoming", "abbr": "WY"}]
	},
	{ "name": "Canada", "abbr": "CA", "states": [{ "name": "Alberta", "abbr": "AB" },
	{ "name": "British Columbia", "abbr": "BC" },
	{ "name": "Manitoba", "abbr": "MB" },
	{ "name": "New Brunswick", "abbr": "NB" },
	{ "name": "Newfoundland and Labrador", "abbr": "NL" },
	{ "name": "Northwest Territories", "abbr": "NT" },
	{ "name": "Nova Scotia", "abbr": "NS" },
	{ "name": "Nunavut", "abbr": "NU" },
	{ "name": "Ontario", "abbr": "ON" },
	{ "name": "Prince Edward Island", "abbr": "PE" },
	{ "name": "Quebec", "abbr": "QC" },
	{ "name": "Saskatchewan", "abbr": "SK" },
	{ "name": "Yukon", "abbr": "YT"}]
	},
	{ "name": "Mexico", "abbr": "MX", "states": [
	{ "name": "Aguascalientes", "abbr": "AGS" },
	{ "name": "Baja California Norte", "abbr": "BCN" },
	{ "name": "Baja California Sur", "abbr": "BCS" },
	{ "name": "Campeche", "abbr": "CAM" },
	{ "name": "Chiapas", "abbr": "CHIS" },
	{ "name": "Chihuahua", "abbr": "CHIH" },
	{ "name": "Coahuila", "abbr": "COAH" },
	{ "name": "Colima", "abbr": "COL" },
	{ "name": "Distrito Federal", "abbr": "DF" },
	{ "name": "Durango", "abbr": "DGO" },
	{ "name": "Guanajuato", "abbr": "GTO" },
	{ "name": "Guerrero", "abbr": "GRO" },
	{ "name": "Hidalgo", "abbr": "HGO" },
	{ "name": "Jalisco", "abbr": "JAL" },
	{ "name": "México - Estado de", "abbr": "EDM" },
	{ "name": "Michoacán", "abbr": "MICH" },
	{ "name": "Morelos", "abbr": "MOR" },
	{ "name": "Nayarit", "abbr": "NAY" },
	{ "name": "Nuevo León", "abbr": "NL" },
	{ "name": "Oaxaca", "abbr": "OAX" },
	{ "name": "Puebla", "abbr": "PUE" },
	{ "name": "Querétaro", "abbr": "QRO" },
	{ "name": "Quintana Roo", "abbr": "QROO" },
	{ "name": "San Luis Potosí", "abbr": "SLP" },
	{ "name": "Sinaloa", "abbr": "SIN" },
	{ "name": "Sonora", "abbr": "SON" },
	{ "name": "Tabasco", "abbr": "TAB" },
	{ "name": "Tamaulipas", "abbr": "TAMPS" },
	{ "name": "Tlaxcala", "abbr": "TLAX" },
	{ "name": "Veracruz", "abbr": "VER" },
	{ "name": "Yucatán", "abbr": "YUC" },
	{ "name": "Zacatecas", "abbr": "ZAC"}]
	},
	{ "name": "Other International", "abbr": "OINT", "states": [] }
];

function generateSelectBox(id, options, selectedValue) {
	var $ddl = $('<select id="' + id + '"></select>');
	$ddl.append(jQuery('<option></option').val('').html(''));
	$.each(options, function (i, item) {
		$ddl.append(jQuery('<option></option').val(item.name).html(item.name));

		if (selectedValue === item.name) {
			$ddl.find('option:last').attr('selected', 'selected');
		}
	});
	return $ddl;
}

// Finds the states that go with selectedCountry, using the Countries object.
function getStatesForCountry(selectedCountry) {
	for (var i in Countries) {
		var country = Countries[i];
		if (selectedCountry === country.name) {
			return country.states;
		}
	}
	return [];
}

// Sets a field's value based on a related dropdown's value
function setFieldFromDropdown(fieldName) {
	var $dropdown = $('#' + fieldName);

	if ($dropdown.length !== 1) {
		return null;
	}

	var selectedValue = $dropdown.find('option:selected:first').val();

	return selectedValue;
}

// Sets the value of the stateOrProvince field to the newly selected value
function handleStateChanged(eventData) {
	$('#'+eventData.data.stateFieldName).val(setFieldFromDropdown('ddl_' + eventData.data.stateFieldName));
}

// Configures the stateOrProvince field to be a dropdown dependent on the value of the country dropdown. Values are pulled from the Countries object.
function loadStateField(stateFieldName, selectedCountry) {
	var states = getStatesForCountry(selectedCountry);
	var $stateField = $('#' + stateFieldName);
	if (states === null || !$.isArray(states) || states.length < 1) {
		$('#ddl_' + stateFieldName).remove();
		$stateField.show();
		return;
	}

	$stateField.hide();
	var selectedState = $('#'+stateFieldName).val();
	var $stateDropdown = generateSelectBox('ddl_' + stateFieldName, states, selectedState);
	var $existingDropdown = $('#ddl_' + stateFieldName);

	if ($existingDropdown.length < 1) {
		$('#' + stateFieldName).after($stateDropdown);
	} else {
		$existingDropdown.replaceWith($stateDropdown);
	}

	$stateDropdown.change({ 'stateFieldName': stateFieldName }, handleStateChanged);
	$stateDropdown.change();

	document.getElementById('ddl_' + stateFieldName).tabIndex = document.getElementById(stateFieldName).tabIndex;
}

// Sets the value of the country field to the newly selected value and reconfigures the dependent state dropdown.
function handleCountryChanged(eventData) {
	var stateFieldName = eventData.data.stateFieldName;
	var selectedCountry = setFieldFromDropdown(eventData.data.countryFieldName);

	loadStateField(stateFieldName, selectedCountry);
}

// Configures the country field to be a dropdown based on the Country object.
function initializeDynamicStateField(countryFieldName, stateFieldName) {
	var $countryField = $('#' + countryFieldName);
	var selectedCountry = $countryField.val();

	$countryField.change({ 'countryFieldName': countryFieldName, 'stateFieldName': stateFieldName }, handleCountryChanged);

	loadStateField(stateFieldName, selectedCountry);
}

function setCookie(c_name,value,exdays)
{
	var exdate=new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value=escape(value) + ((exdays===null) ? "" : ("; expires="+exdate.toUTCString()));
	document.cookie=c_name + "=" + c_value;
}

function getCookie(c_name)
{
	var i,x,y,ARRcookies=document.cookie.split(";");

	for (i=0;i<ARRcookies.length;i++)
	{
		x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
		y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
		x=x.replace(/^\s+|\s+$/g,"");

		if (x===c_name) {
			return unescape(y);
		}
	}
}
